const tier1Cities = [
  { name: 'Delhi', slug: 'delhi', code: 'DEL' },
  { name: 'Mumbai', slug: 'mumbai', code: 'BOM' },
  { name: 'Bangalore', slug: 'bangalore', code: 'BLR' },
  { name: 'Hyderabad', slug: 'hyderabad', code: 'HYD' },
  { name: 'Chennai', slug: 'chennai', code: 'MAA' },
  { name: 'Pune', slug: 'pune', code: 'PNQ' },
  { name: 'Kolkata', slug: 'kolkata', code: 'CCU' },
];

// Market prices: 6-month avg (Oct 2025 - Mar 2026) + 30% airline price hike factored in
// AirVia discount tiers:
//   Regular > ₹7,000 → AirVia = Regular - ₹1,000
//   Regular ₹5,000-₹6,999 → AirVia = Regular - ₹700
//   Regular < ₹5,000 → AirVia = Regular - ₹500
const routePricing = {
  'delhi-mumbai': { regular: 8200, airvia: 7200, duration: '2h 25m', distance: '1,148 km' },
  'delhi-bangalore': { regular: 11000, airvia: 8500, duration: '2h 45m', distance: '1,740 km' },
  'delhi-hyderabad': { regular: 7800, airvia: 6800, duration: '2h 15m', distance: '1,260 km' },
  'delhi-chennai': { regular: 9800, airvia: 8800, duration: '2h 40m', distance: '1,760 km' },
  'delhi-pune': { regular: 7500, airvia: 6500, duration: '2h 15m', distance: '1,170 km' },
  'delhi-kolkata': { regular: 6800, airvia: 6100, duration: '2h 10m', distance: '1,305 km' },
  'mumbai-bangalore': { regular: 5500, airvia: 4800, duration: '1h 45m', distance: '840 km' },
  'mumbai-hyderabad': { regular: 5500, airvia: 4800, duration: '1h 25m', distance: '620 km' },
  'mumbai-chennai': { regular: 7200, airvia: 6200, duration: '1h 50m', distance: '1,030 km' },
  'mumbai-pune': { regular: 3900, airvia: 3400, duration: '1h 05m', distance: '150 km' },
  'mumbai-kolkata': { regular: 8100, airvia: 7100, duration: '2h 35m', distance: '1,660 km' },
  'bangalore-hyderabad': { regular: 4800, airvia: 4300, duration: '1h 15m', distance: '500 km' },
  'bangalore-chennai': { regular: 4500, airvia: 4000, duration: '1h 00m', distance: '290 km' },
  'bangalore-pune': { regular: 5800, airvia: 5100, duration: '1h 30m', distance: '735 km' },
  'bangalore-kolkata': { regular: 8500, airvia: 7500, duration: '2h 30m', distance: '1,560 km' },
  'hyderabad-chennai': { regular: 6800, airvia: 6100, duration: '1h 15m', distance: '520 km' },
  'hyderabad-pune': { regular: 5500, airvia: 4800, duration: '1h 20m', distance: '500 km' },
  'hyderabad-kolkata': { regular: 7500, airvia: 6500, duration: '2h 05m', distance: '1,190 km' },
  'chennai-pune': { regular: 6800, airvia: 6100, duration: '1h 45m', distance: '870 km' },
  'chennai-kolkata': { regular: 7200, airvia: 6200, duration: '2h 15m', distance: '1,370 km' },
  'pune-kolkata': { regular: 7800, airvia: 6800, duration: '2h 25m', distance: '1,580 km' },
};

function getRouteKey(fromSlug, toSlug) {
  const key1 = `${fromSlug}-${toSlug}`;
  const key2 = `${toSlug}-${fromSlug}`;
  return routePricing[key1] ? key1 : key2;
}

function getRouteData(fromSlug, toSlug) {
  const key = getRouteKey(fromSlug, toSlug);
  return routePricing[key] || { regular: 6500, airvia: 5800, duration: '2h 00m', distance: '1,000 km' };
}

function generateAllRoutes() {
  const routes = [];
  for (let i = 0; i < tier1Cities.length; i++) {
    for (let j = 0; j < tier1Cities.length; j++) {
      if (i !== j) {
        const from = tier1Cities[i];
        const to = tier1Cities[j];
        routes.push({
          from,
          to,
          slug: `${from.slug}-to-${to.slug}`,
          pricing: getRouteData(from.slug, to.slug),
        });
      }
    }
  }
  return routes;
}

const allRoutes = generateAllRoutes();

export { tier1Cities, routePricing, getRouteData, getRouteKey, generateAllRoutes, allRoutes };
